import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const GetParte = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.get(`/partes/${params}`);
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        getParteMutation: mutation.mutate,
    };
}